import { hasSupabaseConfig, supabase } from '../../../shared/api/supabaseClient.js';

function requireSupabaseClient() {
  if (!hasSupabaseConfig || !supabase) throw new Error('Supabase 환경 변수가 설정되지 않았습니다.');
  return supabase;
}

const DELETE_ERROR_MESSAGES = {
  missing_authorization: '로그인 세션을 확인할 수 없습니다. 다시 로그인해주세요.',
  invalid_session: '로그인 세션이 만료되었습니다. 다시 로그인해주세요.',
  confirmation_mismatch: '삭제 확인 문구가 올바르지 않습니다.',
  account_not_active: '현재 상태에서는 계정을 삭제할 수 없습니다.',
  profile_read_failed: '계정 정보를 확인하지 못했습니다.',
  deletion_prepare_failed: '계정 삭제 준비 중 오류가 발생했습니다.',
  auth_delete_failed: '계정을 삭제하지 못했습니다. 잠시 후 다시 시도해주세요.',
  server_not_configured: '계정 삭제 서버 설정을 확인해주세요.',
};

function createAccountDeletionError(code, fallbackMessage) {
  const error = new Error(DELETE_ERROR_MESSAGES[code] || fallbackMessage || '계정 삭제 중 오류가 발생했습니다.');
  error.code = code || 'unknown_error';
  return error;
}

async function readFunctionErrorCode(error) {
  try {
    const payload = await error?.context?.json();
    return payload?.code || '';
  } catch {
    return '';
  }
}

export async function deleteCurrentAccount({ confirmationText }) {
  const client = requireSupabaseClient();
  const { data, error } = await client.functions.invoke('delete-account', {
    body: { confirmationText: String(confirmationText || '').trim() },
  });

  if (error) {
    const code = await readFunctionErrorCode(error);
    throw createAccountDeletionError(code, error.message);
  }
  if (!data?.ok) throw createAccountDeletionError(data?.code);

  try {
    await client.auth.signOut({ scope: 'local' });
  } catch {
    // Auth 사용자가 이미 삭제된 뒤이므로 로컬 로그아웃 실패는 삭제 성공을 되돌리지 않는다.
  }
  return data;
}
